import { FunctionComponent, PropsWithChildren } from 'react';

interface SecondaryMenuHeaderProps extends PropsWithChildren {}

export const SecondaryMenuHeader: FunctionComponent<SecondaryMenuHeaderProps> = ({ children }) => {
  return <div className="text-lg font-black uppercase text-gray-800 dark:text-gray-300 ">{children}</div>;
};
